<template>
  <v-flex>
    <div class="modal-send-message__text">
      PRICE RANGE
      <div class="inform-container">
        <span>
          Min
          <input
            v-model="profile.priceMin"
            v-money="money"
            type="text"
            :placeholder="placeholderMin"
            @click="profile.priceMin = null"
          ></span>
        <span>
          Max
          <input
            v-model="profile.priceMax"
            v-money="money"
            type="text"
            :placeholder="placeholderMax"
            @click="profile.priceMax = null"
          ></span>
      </div>
      <div>
        GOAL DATE
        <br>
        <v-menu
          ref="datePicker"
          v-model="data.dataPicker"
          :close-on-content-click="false"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field v-model="dateFormatted" readonly v-on="on" />
          </template>
          <v-date-picker v-model="date" no-title scrollable>
            <v-spacer />
            <v-btn flat color="primary" @click="data.dataPicker = false">
              Cancel
            </v-btn>
            <v-btn flat color="primary" @click="updateDateToDatePicker">
              OK
            </v-btn>
          </v-date-picker>
        </v-menu>
      </div>
    </div>
    <div class="update-details-modal-content">
      <v-btn
        class="update-details-modal-button"
        :color="colors.hwayzBrandBlue"
        @click="updateInfo()"
      >
        SAVE CHANGES
      </v-btn>
      <v-btn
        class="update-details-modal-button update-details-modal-button-cancel"
        color="white"
        @click.stop="$emit('close-modal')"
      >
        CANCEL
      </v-btn>
    </div>
  </v-flex>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import colors from '../../scss/_colors.scss'
import { updateProfileById } from '../../services/profile'
import { VMoney } from 'v-money'
export default {
  directives: { money: VMoney },
  props: {
    text: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: 'OK'
    }
  },
  data() {
    return {
      colors,
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      data: {
        dataPicker: false
      },
      width: 450,
      profile: {
        priceMin: null,
        priceMax: null,
        goalDate: null
      },
      money: {
        decimal: ',',
        thousands: ',',
        prefix: '$',
        precision: 0
      },
      placeholderMin: '$100000',
      placeholderMax: '$3000000'
    }
  },
  computed: {
    ...mapState('style', ['modal']),
    ...mapState('client', ['clientData']),
    ...mapState('agent', ['agentData']),
    ...mapState('common', ['profileStatus'])
  },
  watch: {
    clientData() {
      this.mapClientDetails()
    },
    date() {
      this.dateFormatted = this.formatDate(this.date)
    }
  },
  created() {
    this.mapClientDetails()
  },
  methods: {
    ...mapMutations('client', {
      setClientData: 'SET_CLIENT_DATA'
    }),
    ...mapMutations('agent', {
      setAgentData: 'SET_AGENT_DATA'
    }),
    async updateInfo() {
      const newData = this.normilizeProfile(this.profile)
      this.$emit('close-modal')

      const updatedDetails = (
        await updateProfileById(this.clientData._id, newData)
      ).data
      if (this.profileStatus !== 'client') {
        let updatedAgentData = { ...this.agentData }
        updatedAgentData.clients = updatedAgentData.clients.map(c => {
          if (c._id === updatedDetails._id) {
            return updatedDetails
          }
          return c
        })
        this.setAgentData(updatedAgentData)
      }
      this.setClientData(updatedDetails)
    },
    mapClientDetails() {
      for (let key in this.profile) {
        if (this.clientData && this.clientData[key]) {
          this.profile[key] = this.clientData[key]
        }
      }
      if (this.profile.goalDate) {
        this.date = new Date(this.profile.goalDate).toISOString().substr(0, 10)
      }
    },
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${month}-${day}-${year}`
    },
    parseDate(date) {
      if (!date) return null
      const [month, day, year] = date.split('-')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    updateDateToDatePicker() {
      this.profile.goalDate = this.parseDate(this.dateFormatted)
      this.data.dataPicker = false
    },
    normilizeProfile(profile) {
      const updatedProfile = { ...profile }
      updatedProfile.priceMin = parseInt(
        updatedProfile.priceMin.replace(/[,$]/g, '')
      )
      updatedProfile.priceMax = parseInt(
        updatedProfile.priceMax.replace(/[,$]/g, '')
      )
      return updatedProfile
    }
  }
}
</script>

<style lang="sass" scoped>
.modal-close
  @extend %modal__button-close, %disable-selection
.modal-send-message__text
  display: flex
  flex-direction: column
  text-align: left
  font-weight: 500
  font-size: 1.1rem
.modal-send-message__text span
  color: $hwayzMediumGray
  font-size: 1.2rem
.inform-container
  display: flex
  flex-direction: row
  justify-content: space-between
  margin: 0.5rem 0 3rem
.update-details-modal-content
  padding: 2rem
  display: inline-block
  box-shadow: none
  width: 100%
.update-details-modal-button
  width: 100%
  border-radius: 5px
  color: $hwayzWhite !important
  font-weight: 500 !important
  font-size: 1.2rem
  margin: 4px auto
  &-cancel
    border: 1px solid $hwayzMediumGray !important
    color: $hwayzBlack !important
.update-details-modal-button:hover
  background-color: $hwayzBrandGold !important
.update-details-modal-button-cancel:hover
  color: $hwayzWhite !important
  border: none !important
input[type=text], .v-text-field
  border: 1px solid $color-grey
  height: 35px
  width: 150px
  vertical-align: middle
  font-size: 1.2rem
input[type=text]
  margin-left: 10px
  padding-left: 20px
  color: $hwayzBlack
input[type=text]:focus::-webkit-input-placeholder
  color: transparent
input[type=text]::-webkit-inner-spin-button,
input[type=text]::-webkit-outer-spin-button
  -webkit-appearance: none
  margin: 0
.v-text-field
  padding: 0 2rem !important
  font-weight: 350
@media only screen and (min-width: 600px)
  .update-details-modal-content
    padding: 3rem 0 0
</style>
